import { createContext, useContext, useState } from "react";
import { CONTENT } from "../i18n/content";

const LangContext = createContext(null);

const savedLang = () => {
  try {
    const l = window.localStorage.getItem("gg_lang");
    return CONTENT[l] ? l : "it";
  } catch {
    return "it";
  }
};

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(savedLang());
  const setLang = (l) => {
    setLangState(l);
    try {
      window.localStorage.setItem("gg_lang", l);
    } catch {}
  };
  const value = { lang, setLang, t: CONTENT[lang] };
  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);
